import React, { useEffect, useState } from "react";

/**
 * Slim gradient progress bar at very top of viewport.
 * Reflects vertical scroll position on the page.
 */
export default function ScrollProgress() {
  const [w, setW] = useState(0);
  useEffect(() => {
    const update = () => {
      const h = document.documentElement;
      const max = (h.scrollHeight - h.clientHeight) || 1;
      setW(Math.min(100, Math.max(0, (h.scrollTop / max) * 100)));
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  return (
    <div
      aria-hidden
      className="fixed top-0 inset-x-0 z-[60] h-[3px] bg-transparent pointer-events-none"
      data-testid="scroll-progress"
    >
      <div
        className="h-full bg-gradient-to-r from-[#A53A2A] via-[#C89B3C] to-[#1E4F87] transition-[width] duration-150 ease-out shadow-[0_0_10px_rgba(165,58,42,0.4)]"
        style={{ width: `${w}%` }}
      />
    </div>
  );
}
